export enum LogoTypes {
        Email = 1,
        System = 2,
        Print = 3
}
